import { util } from '../util/axiosConf';
import qs from 'qs';
const  pre = 'api/licenselmp';
export default {
  
  //添加
  addAuthCode(processNo,licenseNo,step) {
    return util.get(`${pre}/lmp/activate/add?processNo=${processNo}&licenseNo=${licenseNo}&step=${step}`);
  },
  //批量追加授权码
  importExcel(processNo,file){
    return util.post(`${pre}/lmp/activate/importExcel?processNo=${processNo}`,file)
  },
  //移除
  remove(params){
    return util.delete(`${pre}/lmp/activate/remove`,{params:params,paramsSerializer: params => {
      return qs.stringify(params, { indices: false });
    },})
  },
  //授权码清单模板
  getListModel(){
    return util.get(`${pre}/lmp/activate/excel`);
  },
  //确认并激活
   confirmActivate(processNo) {
    return util.get(`${pre}/lmp/activate/confirm?processNo=${processNo}`);
  },
  //获取用户
  getUser(processNo) {
    return util.get(`${pre}/lmp/activate/customer?processNo=${processNo}`);
  },
  //保存用户
  saveUser(params){
    return util.post(`${pre}/lmp/activate/customer/save`,params)
  },
  //分页查询
   getList(params) {
    return util.get(`${pre}/lmp/activate/page`,{params:params});
  },
  getListUrl:`${pre}/lmp/activate/page`,
  //录入设备
  inputDevice(data,params){
    return util.post(`${pre}/lmp/activate/inputDevice?tag=${params.tag}&processNo=${params.processNo}`,data)
  },
  //下一步
  nextStep(param){
    return util.post(`${pre}/lmp/activate/nextStep`,param)
  },
  //查询详情
  getDetail(id){
    return util.get(`${pre}/lmp/authorize/created/productdetail?id=${id}`)
  },
  //发送邮件-确认激活页
  sendEmailToActive(customerId,zipUrl,processNo){
    return util.get(`${pre}/lmp/activate/sendEmail1?customerId=${customerId}&zipUrl=${zipUrl}&processNo=${processNo}`)
  },
  //发送邮件
  sendEmailForDetail(productDetailId){
    return util.get(`${pre}/lmp/activate/sendEmail2?productDetailId=${productDetailId}`)
  },
};
